import { Button } from 'primereact/button'

import { PermissionSuffix } from '../../../_generated/api/user-management'
import { Column, Row } from './FlexContainer'
import ClassNameBuilder from '../../../tools/ClassNameBuilder'
import t from '../../../tools/t'

const PERMISSION_ORDER = {
    [PermissionSuffix.UserWrite]: t('permission_tenant_user'),
    // [PermissionSuffix.OrganizationWrite]: t('permission_tenant'),
    [PermissionSuffix.StructureWrite]: t('permission_structure'),
    [PermissionSuffix.HardwareWrite]: t('permission_hardware'),
    [PermissionSuffix.DeviceApp]: t('permission_device'),
}

interface PermissionsSwitchListProps {
    selectedPermissions: PermissionSuffix[]
    onChange: (permissions: PermissionSuffix[]) => void
    disabled?: boolean
}
export const PermissionSwitchList = ({
    selectedPermissions,
    onChange,
    disabled,
}: PermissionsSwitchListProps) => (
    <SwitchList
        options={PERMISSION_ORDER}
        selectedOptions={selectedPermissions}
        onChange={(permissions) => onChange(permissions as PermissionSuffix[])}
        disabled={disabled}
    />
)

interface SwitchListProps {
    options: Record<string, string>
    selectedOptions: string[]
    onChange: (options: string[]) => void
    disabled?: boolean
}
export default function SwitchList({
    options,
    selectedOptions,
    onChange,
    disabled,
}: SwitchListProps) {
    const onOptionChange = (option: string) => {
        if (disabled) return
        let updated = [...selectedOptions]
        if (updated.includes(option)) updated = updated.filter((o) => o !== option)
        else updated.push(option)
        onChange(updated)
    }
    return (
        <Column className="switch-list">
            {Object.keys(options).map((o) => (
                <SwitchListRow
                    key={o}
                    text={options[o]}
                    selected={selectedOptions.includes(o)}
                    disabled={disabled}
                    onToggle={() => onOptionChange(o)}
                />
            ))}
        </Column>
    )
}

interface SwitchListRowProps {
    text: string
    selected: boolean
    disabled?: boolean
    onToggle: () => void
}
const SwitchListRow = ({ text, selected, disabled, onToggle }: SwitchListRowProps) => {
    const buildButtonClassName = (isButtonSelected: boolean) =>
        new ClassNameBuilder()
            .add('switch-list__switch-button')
            .addIf('switch-list__switch-button--selected', isButtonSelected)
            .toString()
    return (
        <Row className="switch-list__row" alignment="center" arrangement="spaced">
            <div>{text}</div>
            <Row gap={1}>
                <Button
                    className={buildButtonClassName(selected)}
                    onClick={selected || disabled ? undefined : onToggle}
                    label={t('common_boolean_yes')}
                    outlined
                    severity="secondary"
                    disabled={disabled}
                />
                <Button
                    className={buildButtonClassName(!selected)}
                    onClick={selected && !disabled ? onToggle : undefined}
                    label={t('common_boolean_no')}
                    outlined
                    severity="secondary"
                    disabled={disabled}
                />
            </Row>
        </Row>
    )
}
